export const TREATMENT1_TYPEID = 1;
export const TREATMENT2_TYPEID = 2;

export const INVANTAR_INTERCEPTIV_APPARATUR_STATUSID = 8;
export const UNDER_BEHANDLING_STATUSID = 9;